(function () {
  function handleTabClick() {
    const activeClass = 'is-active';
    const tabPanelEls = document.querySelectorAll('.js-tab-panel');
    const tabButtonEls = document.querySelectorAll('.js-tab');
    const tabTarget = this.dataset.tabtarget;
    const activeTabPanelEl = document.querySelector(`[data-tabpanel=${tabTarget}]`);
    const paymentMethodField = document.getElementById('selectedPaymentMethod') as HTMLInputElement;

    paymentMethodField.value = tabTarget;

    tabButtonEls.forEach((tabButton) => {
      tabButton.classList.remove(activeClass);
    });

    tabPanelEls.forEach((tabPanel) => {
      tabPanel.classList.remove(activeClass);
    });

    activeTabPanelEl.classList.add(activeClass);
    this.classList.add(activeClass);
  }

  const tabEls = document.querySelectorAll('.js-tab');

  tabEls.forEach((tab) => {
    tab.addEventListener('click', handleTabClick);
  });
})();
